import React, { useEffect, useState } from "react";
import MainPage from "./Components/MainPage";
import ImagePage from "./Components/ImagePage";
import TemplatesPage from "./Components/TemplatesPage";
import YearPage from "./Components/YearPage";
import PreviewPage from "./Components/PreviewPage";
import useTemplateInstance from "../../hooks/useTemplateInstance";
import SelectImagePage from "./Components/SelectImagePage";
import SelectTextPage from "./Components/SelectTextPage";
import TextPage from "./Components/TextPage";
import BuyPage from "./Components/BuyPage";
import { templateFontList } from "./common";
import useGoogleFonts from "../../../../hooks/useGoogleFonts";
import {
  ACTIONS,
  getCurrentResource,
} from "../../../../Providers/TemplateInstanceProvider";

const EditTemplateProduct = ({
  handleGoBack,
  mode,
  updateCart,
  handleCartButtonClick,
  cartButtonLabel,
  allowSubjectChange,
  allowTemplateChange,
  handleChangeAllPackagePictures,
  isPackage,
}) => {
  const [currentMenu, setCurrentMenu] = useState("main");
  const [state, dispatch] = useTemplateInstance();
  const { loaded: fontsLoaded } = useGoogleFonts(templateFontList);

  useEffect(() => {
    console.log("Use effect, resourceid");
    if (!state.currentResourceId) {
      setCurrentMenu("main");
      return;
    }

    const resource = getCurrentResource(state);

    if (resource.type == "IMAGE") {
      setCurrentMenu("image");
    } else if (resource.type == "STRING") {
      setCurrentMenu("string");
    }
  }, [state.currentResourceId]);

  useEffect(() => {
    if (currentMenu == "main" && state.currentResourceId) {
      dispatch({
        type: ACTIONS.SET_CURRENT_RESOURCE,
        id: null,
      });
    }
  }, [currentMenu]);

  const changeMenu = (menu) => setCurrentMenu(menu);

  if (!state.template && !fontsLoaded) {
    return <div>Loading</div>;
  }

  switch (currentMenu) {
    case "main":
      return (
        <MainPage
          changeMenu={changeMenu}
          handleGoBack={handleGoBack}
          mode={mode}
          updateCart={updateCart}
          isPackage={isPackage}
          allowTemplateChange={allowTemplateChange}
          handleCartButtonClick={handleCartButtonClick}
          cartButtonLabel={cartButtonLabel}
        />
      );
    case "select-image":
      return <SelectImagePage changeMenu={changeMenu} />;
    case "image":
      return (
        <ImagePage
          changeMenu={changeMenu}
          allowSubjectChange={allowSubjectChange}
          handleChangeAllPackagePictures={handleChangeAllPackagePictures}
        />
      );
    case "select-text":
      return <SelectTextPage changeMenu={changeMenu} />;
    case "text":
    case "string":
      return <TextPage changeMenu={changeMenu} />;
    case "templates":
      return <TemplatesPage changeMenu={changeMenu} />;
    case "year":
      return <YearPage changeMenu={changeMenu} />;
    case "preview":
      return <PreviewPage changeMenu={changeMenu} />;
    case "buy":
      return <BuyPage changeMenu={changeMenu} />;
  }

  return null;
};

export default EditTemplateProduct;
